import * as moment from 'moment';

export function gfDateFunction(inputValue, format?, locale?) {
    format = format || 'll';
    var r =  moment(inputValue);
    if (!r.isValid()) {
        return '(none)';
    }
    locale = locale || moment.locale();

    return r.locale(locale).format(format);
};

export function gfToDateFunction(inputValue, locale?) {
    if (inputValue === undefined || inputValue === null || inputValue === '') {
        return null;
    }

    if (inputValue instanceof Date) {
        return inputValue;
    }
    locale = locale || moment.locale();

    var r = moment(inputValue);
    if (!r.isValid()) {
        return null;
    }

    return r.locale(locale).toDate();
};

export function gfUtcDateFunction(inputValue, format, locale?) {
    format = format || 'll';
    var r =  moment(inputValue);
    if (!r.isValid()) {
        return '(none)';
    }
    locale = locale || moment.locale();

    return r.utcOffset(0).locale(locale).format(format);
};

export function gfRelativeDateFunction(inputValue, locale) {
    var then = inputValue;
    if (typeof then === 'string') {
        then = gfToDateFunction(inputValue, locale);
    }
    if (then === null || !(then instanceof Date)) {
        return '';
    }

    locale = locale || moment.locale();

    return moment(then).locale(locale).calendar(null, {
        sameElse: 'll'
    });
};